/*global Calendly*/

/**
 * Represents a Calendly popup.
 */
const calendlyPopup = () => {

	const buttons = document.querySelectorAll( 'a[href*="https://calendly.com/"]' );

	if ( buttons ) {

		document.body.appendChild( document.createElement( 'div' ) ).className = 'msp-buttons-group';


		buttons.forEach( ( button ) => {

			button.classList.add( 'msp-buttons', 'msp-btn-success' );

			button.addEventListener( 'click', ( e ) => {

				e.preventDefault()
				Calendly.initPopupWidget( { url: button.href } );

			} )

		} )

	}

}
export { calendlyPopup };
